<template>
  <section class="uploadSentencePage">
    <popup v-show="isShowUploadSentence" bread="教材管理,课程管理,设置主题资料,编辑句型资料" title="编辑句型资料" @onBack="popup_back">
      <template slot="button">
        <el-button type="success" @click="saveUploadHighFrequencyWord">保存并上传</el-button>
      </template>
      <infoUpDown :bread="'编辑句型资料'">
        <h3 class="group-tit">句型资料</h3>
        <commonUploadSentence
          ref="ref_commonUploadSentence"
          :key="timestamp"
          :max-number="(30-currentNumber)"
          code="jx"
          :form.sync="form"
          @formChange="commonUploadSentenceChange"
        />
      </infoUpDown>
    </popup>
  </section>
</template>

<script>
import commonUploadSentence from '../components/commonUploadSentence'
import { editSentencePattern } from '../../../../api/teachBookManagement/courseManagement'
import { functionData } from '../../../../utils/reg'
import { mapState } from 'vuex'
export default {
  components: {
    commonUploadSentence
  },
  props: {
    currentNumber: {
      type: Number,
      default: 0
    },
    timestamp: {
      type: Number,
      default: 0
    },
    themeRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isShowUploadSentence: false,
      commonUploadForm: {},
      form: {}
    }
  },
  computed: {
    ...mapState('settingThemeData', ['editSentenceList'])
  },
  watch: {
    timestamp: function (val) {
      this.isShowUploadSentence = true
      const info = this.dataChange()
      this.form = info
    }
  },
  created () {

  },
  methods: {
    dataChange() {
      console.log(this.editSentenceList)
      const array = {
        sentenceList: []
      }
      for (const i in this.editSentenceList) {
        const item = {
          sentencePatternName: this.editSentenceList[i].wordName,
          voice: functionData(this.editSentenceList[i], 'pronunciation', 'Pronunciation'),
          img: functionData(this.editSentenceList[i], 'cardChart', 'CardChart'),
          // voice: [
          //   { name: this.editSentenceList[i].pronunciationName,
          //     id: this.editSentenceList[i].id,
          //     url: this.editSentenceList[i].pronunciationPath }
          // ],
          // img: [
          //   { name: this.editSentenceList[i].cardChartName,
          //     id: this.editSentenceList[i].id,
          //     url: this.editSentenceList[i].cardChartPath }
          // ],
          id: this.editSentenceList[i].id,
          basicCode: this.editSentenceList[i].basicCode

        }
        console.log(array)
        array.sentenceList.push(item)
      }
      return array
    },
    // 返回
    popup_back () {
      this.isShowUploadSentence = false
      // this.$emit('resetFetchData')
    },
    commonUploadSentenceChange (form) {
      this.commonUploadForm = form
    },
    async saveUploadHighFrequencyWord () {
      if (!this.$refs.ref_commonUploadSentence.validateForm()) {
        this.$message.error('请正确填写信息')
        return false
      }
      const params = []
      for (const item of this.form.sentenceList) {
        params.push({
          sentencePatternName: item.sentencePatternName.trim(),
          cardChartName: item.img[0].paramsFileName || item.img[0].fileName,
          cardChartPath: item.img[0].matchPathName || item.img[0].paramsUrl,
          sentencePronunciationName: item.voice[0].paramsFileName || item.voice[0].fileName,
          sentencePronunciationPath: item.voice[0].matchPathName || item.voice[0].paramsUrl,
          isSpeaking: 1,
          teachingThemeId: this.themeRow.id,
          meansType: 6,
          id: item.id
        })
      }
      console.log(params)
      try {
        await Promise.all(params.map(async (item) => {
          // 等待异步操作完成，返回执行结果
          return await editSentencePattern({ list: [item] })
        }))
        this.$message.success('编辑成功')
        this.isShowUploadSentence = false
        this.$emit('resetFetchData')
      } catch (e) {
        this.$message.closeAll()
        this.$message.error(e)
      }
    }

  }
}
</script>

<style lang='scss'>
.uploadSentencePage{
  .group-tit{
    margin: 24px 0;color:#53402B;display: flex;
    align-items: center;
    span{color: #898884;}
    &::before{
      content: '';
      width: 6px;
      height: 22px;
      display: inline-block;
      background: #FCDA6F;
      margin-right: 8px;
      border-radius: 9px;
    }
  }
}
.upload-form-self{
  display: flex;
  flex-wrap: wrap;
  .el-form-item{
    width: 40%;
    &:nth-child(odd){
      margin-right: 10%;
    }
  }
}
</style>
